<div [ngClass]="{ 'small-view-styling': !isViewSmall, 'normal-view-styling': isViewSmall }">
   <kendo-dropdownlist
      #dropdownList
      [ngClass]="{ hidden: !showDropDown }"
      class="sam-full-width"
      [data]="possibleUserStates$ | async"
      [value]="(currentUserStatusInfo$ | async)?.id"
      [valuePrimitive]="true"
      [disabled]="disabled"
      valueField="id"
      textField="name"
      (selectionChange)="requestUserStatusChange($event)"
   >
      <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
         <samweb-agent-status *ngIf="dataItem" [statusInfo]="dataItem"></samweb-agent-status>
      </ng-template>
   </kendo-dropdownlist>
   <div>
      <samweb-user-status-progressbar [showProgressbar]="true" [userId]="userId"> </samweb-user-status-progressbar>
   </div>
</div>
